import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { CSSProperties } from 'react';
import { Separator } from 'react-resizable-panels';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { Placement } from '../Tooltip/Tooltip.types';
import { useResizeSeparatorStyles } from './resizeSeparator.styles';

type ResizeSeparatorOrientation = 'vertical' | 'horizontal';

interface ResizeSeparatorProps {
  label: LangEnum;
  hint: LangEnum;
  orientation?: ResizeSeparatorOrientation;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
}

const HINT_PLACEMENT_BY_ORIENTATION: Record<ResizeSeparatorOrientation, Placement> = {
  vertical: 'left',
  horizontal: 'top',
};

const ResizeSeparator = ({
  label,
  hint,
  orientation = 'vertical',
  disabled = false,
  className,
  style,
}: ResizeSeparatorProps) => {
  const { translate } = useTranslation();
  const { classes, cx } = useResizeSeparatorStyles({ isVertical: orientation === 'vertical' });

  return (
    <Separator
      className={cx(classes.separator, className)}
      disabled={disabled}
      aria-label={translate(label)}
      style={style}
    >
      <Tooltip
        anchorToCursor
        tabIndex={-1}
        placement={HINT_PLACEMENT_BY_ORIENTATION[orientation]}
        TooltipContent={translate(hint)}
      >
        <span className={classes.hitArea} />
      </Tooltip>
    </Separator>
  );
};

export default ResizeSeparator;
